import React from "react";
import ActivityCard from "../components/ActivityCard";
import { useLang } from "../context/LanguageContext";
import { activities } from "../data/activities";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const Activities = () => {
  const { t } = useLang();
  return (
    <div data-testid="activities-page" className="pt-28 md:pt-36">
      <section className="container-x pb-14">
        <p className="label-eyebrow">{t.activities.eyebrow}</p>
        <h1 className="h-display mt-6 max-w-4xl text-5xl md:text-7xl font-light text-[#0B192C]">
          {t.activities.title}
        </h1>
        <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-[#475569] font-light">
          {t.activities.subtitle}
        </p>
      </section>

      <section className="container-x pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {activities.map((a) => (
            <ActivityCard key={a.id} activity={a} variant={a.span} />
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="section-pad bg-[#F7F5F0]" data-testid="faq-section">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="label-eyebrow">{t.faq.eyebrow}</p>
            <h2 className="h-display mt-4 text-3xl md:text-5xl font-light text-[#0B192C]">
              {t.faq.title}
            </h2>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((it, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/10" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left text-lg md:text-xl font-medium text-[#0B192C] py-6 hover:no-underline">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] font-light text-base leading-relaxed pb-6">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Activities;
